import { createFileRoute } from "@tanstack/react-router";

import { SplitOrdersPage } from "@/features/orders";

export const Route = createFileRoute("/_authenticated/split-orders")({
  component: SplitOrdersPage,
});
